<template>
  <v-dialog v-model="opened" :max-width="id ? '1200' : '800'" persistent>
    <user-wizard
      ref="wizard"
      :close="close"
      :change="stepChanged"
      v-if="id"
      :can-change-password="canChangePassword"
    >
      <div v-if="step == 1">
        <v-form
          ref="form"
          v-model="valid"
          :readonly="!canEdit"
          @submit.prevent="save()"
        >
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <!-- Personal Information -->
                <div style="margin-top: -20px">
                  <div class="ml-3">Foto Profil</div>
                  <FileUpload
                    v-model="data.profile_picture"
                    :requied="true"
                    :labelIdle="'Foto Thumbnail '"
                    category="profile-picture"
                    class="mb-6"
                    :showCameraButton="true"
                  ></FileUpload>
                </div>
                <v-text-field
                  label="Nama Lengkap"
                  required
                  dense
                  outlined
                  v-model="data.name"
                  :rules="rules.name"
                ></v-text-field>
                <v-text-field
                  label="NIK"
                  dense
                  outlined
                  autocomplete="off"
                  v-model="data.identity_number"
                  :rules="rules.identity_number"
                ></v-text-field>
                <v-select
                  :items="[
                    { text: 'Laki-Laki', value: 'L' },
                    { text: 'Perempuan', value: 'P' },
                  ]"
                  label="Jenis Kelamin"
                  outlined
                  dense
                  v-model="data.gender"
                ></v-select>
                <date-picker
                  class="mb-6"
                  placeholder="Tanggal Lahir"
                  valueType="format"
                  :format="'YYYY-MM-DD'"
                  v-model="data.date_of_birth"
                ></date-picker>
                <v-textarea
                  label="Alamat"
                  dense
                  outlined
                  rows="3"
                  v-model="data.address"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <!-- Account & Contact Information -->
                <v-text-field
                  label="Username"
                  dense
                  outlined
                  autocomplete="off"
                  v-model="data.username"
                  :rules="rules.username"
                ></v-text-field>
                <v-text-field
                  label="Email"
                  dense
                  outlined
                  autocomplete="off"
                  v-model="data.email"
                  :rules="rules.email"
                ></v-text-field>
                <v-text-field
                  label="No. Telp"
                  dense
                  outlined
                  v-model="data.phone"
                  :rules="rules.phone"
                  @keypress="isNumber($event)"
                ></v-text-field>
                <v-text-field
                  label="Emergency Contact Name"
                  dense
                  outlined
                  v-model="data.detail_member.emergency_contact_name"
                  :rules="rules.emergency_contact_name"
                ></v-text-field>
                <v-text-field
                  label="Emergency Contact Phone"
                  dense
                  outlined
                  v-model="data.detail_member.emergency_contact_phone"
                  :rules="rules.emergency_contact_phone"
                  @keypress="isNumber($event)"
                ></v-text-field>
                <v-autocomplete
                  label="Referral Member"
                  dense
                  outlined
                  v-model="data.detail_member.referral_member_id"
                  :items="listMembers"
                  item-text="name"
                  item-value="id"
                  :rules="rules.referral_member_id"
                ></v-autocomplete>
                <v-text-field
                  label="Point"
                  required
                  dense
                  outlined
                  v-model="data.detail_member.point"
                ></v-text-field>
                <v-checkbox v-model="data.active" label="Aktif"></v-checkbox>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  depressed
                  class="ma-1"
                  :disabled="loading"
                  @click="close()"
                >
                  <v-icon small left>mdi-close</v-icon>
                  Tutup
                </v-btn>
                <v-btn
                  v-if="canEdit"
                  type="submit"
                  color="success"
                  depressed
                  class="ma-1"
                  :loading="loading"
                  :disabled="loading"
                  @click.stop.prevent="save()"
                >
                  <v-icon small left>mdi-content-save</v-icon>
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
      <div v-else-if="step == 2">
        <list-member-progress
          ref="listrole"
          :id="id"
          :can-edit="canEdit"
        ></list-member-progress>
      </div>
      <div v-else-if="step == 3 && canChangePassword">
        <form-change-password
          ref="formChangePassword"
          :id="id"
          :close="close"
        ></form-change-password>
      </div>
      <div v-else-if="step == (canChangePassword ? 4 : 3)">
        <list-user-log ref="listrole" :id="id"></list-user-log>
      </div>
      <div v-else-if="step == (canChangePassword ? 5 : 4)">
        <list-member-referral
          ref="listrole"
          :id="id"
          :can-edit="canEdit"
        ></list-member-referral>
      </div>
      <div v-else-if="step == (canChangePassword ? 6 : 5)">
        <list-member-package-history
          ref="listMemberPackageHistory"
          :id="id"
        ></list-member-package-history>
      </div>
    </user-wizard>
    <template v-else>
      <v-form ref="formNewUser" v-model="valid">
        <v-card>
          <v-card-title class="headline">Tambah Member</v-card-title>
          <v-card-text class="px-2">
            <v-container>
              <v-row justify="center">
                <v-col cols="6">
                  <!-- Personal Information -->
                  <div style="margin-top: -20px">
                    <div class="text-subtitle-1">Foto Profil</div>
                    <FileUpload
                      v-model="data.profile_picture"
                      :requied="true"
                      :labelIdle="'Foto Thumbnail '"
                      category="profile-picture"
                      class="mb-6"
                      :showCameraButton="true"
                    ></FileUpload>
                  </div>
                  <v-text-field
                    label="Nama Lengkap"
                    required
                    dense
                    outlined
                    v-model="data.name"
                    :rules="rules.name"
                  ></v-text-field>
                  <v-text-field
                    label="NIK/Passport"
                    dense
                    outlined
                    autocomplete="off"
                    v-model="data.identity_number"
                    :rules="rules.identity_number"
                  ></v-text-field>
                  <v-select
                    :items="[
                      { text: 'Laki-Laki', value: 'L' },
                      { text: 'Perempuan', value: 'P' },
                    ]"
                    label="Jenis Kelamin"
                    outlined
                    dense
                    v-model="data.gender"
                  ></v-select>
                  <date-picker
                    class="mb-6"
                    placeholder="Tanggal Lahir"
                    valueType="format"
                    :format="'YYYY-MM-DD'"
                    v-model="data.date_of_birth"
                  ></date-picker>
                  <v-textarea
                    label="Alamat"
                    dense
                    outlined
                    rows="3"
                    v-model="data.address"
                  ></v-textarea>
                </v-col>
                <v-col cols="6">
                  <!-- Account & Contact Information -->
                  <v-text-field
                    label="Username"
                    dense
                    outlined
                    v-model="data.username"
                    :rules="rules.username"
                  ></v-text-field>
                  <v-text-field
                    label="Email"
                    required
                    dense
                    outlined
                    v-model="data.email"
                    :rules="rules.email"
                  ></v-text-field>
                  <v-text-field
                    label="No. Telp"
                    dense
                    outlined
                    v-model="data.phone"
                    :rules="rules.phone"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                  <v-text-field
                    label="Emergency Contact Name"
                    dense
                    outlined
                    v-model="data.detail_member.emergency_contact_name"
                    :rules="rules.emergency_contact_name"
                  ></v-text-field>
                  <v-text-field
                    label="Emergency Contact Phone"
                    dense
                    outlined
                    v-model="data.detail_member.emergency_contact_phone"
                    :rules="rules.emergency_contact_phone"
                    @keypress="isNumber($event)"
                  ></v-text-field>
                  <v-autocomplete
                    label="Referral Member"
                    dense
                    outlined
                    v-model="data.detail_member.referral_member_id"
                    :items="listMembers"
                    item-text="name"
                    item-value="id"
                    :rules="rules.referral_member_id"
                  ></v-autocomplete>
                  <v-text-field
                    label="Point"
                    required
                    dense
                    outlined
                    v-model="data.detail_member.point"
                  ></v-text-field>
                  <v-text-field
                    label="Password"
                    :type="showPassword ? 'text' : 'password'"
                    required
                    dense
                    outlined
                    autocomplete="off"
                    v-model="data.password"
                    :rules="rules.password"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                  <v-text-field
                    label="Ketik Ulang Password"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    required
                    dense
                    outlined
                    autocomplete="off"
                    v-model="confirmPassword"
                    :rules="rules.confirmPassword"
                    :append-icon="
                      showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  ></v-text-field>
                  <v-checkbox
                    v-model="data.active"
                    true-value="true"
                    false-value="false"
                    label="Aktif"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  depressed
                  class="ma-1"
                  :disabled="loading"
                  @click="close()"
                >
                  <v-icon small left>mdi-close</v-icon>
                  Tutup
                </v-btn>
                <v-btn
                  type="submit"
                  color="success"
                  depressed
                  class="ma-1"
                  :loading="loading"
                  :disabled="loading"
                  @click.stop.prevent="saveNewUser()"
                >
                  <v-icon small left>mdi-content-save</v-icon>
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </template>
  </v-dialog>
</template>

<script>
import { isNumber } from "@/core/utils";
import ApiService from "@/core/services/api.service";
import UserWizard from "./UserWizard";
import ListMemberProgress from "./member-progress/ListMemberProgress";
import ListUserLog from "./user-log/ListUserLog";
import FormChangePassword from "./change-password/FormChangePassword";
import FileUpload from "@/view/component/FileUpload.vue";
import ListMemberReferral from "./member-referral/ListMemberReferral";
import ListMemberPackageHistory from "./user-log/ListMemberPackageHistory";

export default {
  async mounted() {
    if (this.data.active == null) {
      this.data.active = true;
    }

    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;
  },
  data() {
    return {
      showPassword: false,
      showConfirmPassword: false,
      id: null,
      step: 1,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      confirmPassword: null,
      listMembers: [],
      data: {
        profile_picture: null,
        name: null,
        email: null,
        password: null,
        active: true,
        identity_number: null,
        username: null,
        detail_member: {
          emergency_contact_name: null,
          emergency_contact_phone: null,
          referral_member_id: null,
          point: null,
        },
      },
      rules: {
        username: [
          (v) => !!v || "Username is required",
          (v) =>
            /^(?=[a-zA-Z0-9._]{3,100}$)(?!.*[_.]{2})[^_.].*[^_.]$/.test(v) ||
            "Username only contains alphanumeric characters, underscore, dot and must between 3 to 100 character.",
        ],
        name: [
          (v) => !!v || "Name is required",
          (v) =>
            (v && v.length <= 100) || "Name must be less than 100 characters",
        ],
        email: [
          (v) => {
            if (v && !/.+@.+\..+/.test(v)) {
              return "E-mail must be valid";
            }
            return true;
          },
        ],
        identity_number: [
          (v) => !!v || "NIK/Passport is required",
          (v) =>
            (v && v.length <= 16) ||
            "NIK/Passport must be less than 16 characters",
        ],
        phone: [
          (v) => {
            if (!!v && v.length > 20) {
              return "Phone must be less than 20 characters";
            }

            return true;
          },
          (v) => (v && v.length >= 8) || "Minimal 8 karakter",
        ],
        password: [
          (v) => !!v || "Password is required",
          (v) =>
            (v &&
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*~+=[\](){}])(?=.{8,})/.test(
                v
              )) ||
            "Password should have minimum 8 characters, at least one letter, one number and one special character",
        ],
        confirmPassword: [
          (v) => !!v || "Please make sure your passwords match.",
          (v) =>
            (v && v == this.data.password) ||
            "Please make sure your passwords match.",
        ],
        emergency_contact_name: [
          (v) => !!v || "Emergency contact name is required",
          (v) =>
            (v && v.length <= 100) ||
            "Emergency contact name must be less than 100 characters",
        ],
        emergency_contact_phone: [
          (v) => !!v || "Emergency contact phone is required",
          (v) =>
            (v && v.length <= 20) ||
            "Emergency contact phone must be less than 20 characters",
        ],
      },
    };
  },
  props: {
    module: {
      type: String,
    },
    success: {
      type: Function,
      default: function () {},
    },
  },
  methods: {
    open(id) {
      if (id) {
        this.step = 1;

        this.id = id;
        setTimeout(() => {
          this.$refs.form.reset();
          this.$refs.wizard.init();
          if (id) {
            this.getData(id);
          }
        }, 1);
      }
      this.opened = true;
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      await ApiService.get("user?id=" + id)
        .then(({ data }) => {
          this.data = {
            profile_picture: data.profile_picture,
            name: data.name,
            gender: data.gender,
            place_of_birth: data.place_of_birth,
            date_of_birth: data.date_of_birth,
            bio: data.bio,
            email: data.email,
            username: data.username,
            phone: data.phone,
            address: data.address,
            active: data.active,
            password: null,
            identity_number: data.identity_number,
            detail_member: {
              emergency_contact_name: data.detail_member.emergency_contact_name,
              emergency_contact_phone:
                data.detail_member.emergency_contact_phone,
              referral_member_id: data.detail_member.referral_member_id,
              point: data.detail_member.poin,
            },
          };
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
      return true;
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid && this.id) {
        this.loading = true;

        if (this.data.active == null) {
          this.data.active = false;
        }

        ApiService.update("user?id=" + this.id, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    async saveNewUser() {
      this.$refs.formNewUser.validate();
      if (this.valid) {
        this.loading = true;

        ApiService.post("user", this.data)
          .then(({ data }) => {
            if (data.id) {
              this.$refs.formNewUser.reset();
              this.getData(data.id).then(() => {
                this.$refs.wizard.init();
                this.success(data);
                this.$swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: "Data berhasil disimpan",
                  showConfirmButton: false,
                  timer: 3000,
                });

                this.loading = false;
              });
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },
    stepChanged(step) {
      this.step = step;
    },
    close() {
      this.opened = false;
      this.id = null;
      this.step = 1;
      this.data = {
        profile_picture: null,
        name: null,
        email: null,
        password: null,
        active: true,
        identity_number: null,
        username: null,
        detail_member: {
          emergency_contact_name: null,
          emergency_contact_phone: null,
          referral_member_id: null,
          point: null,
        },
      };
      this.$refs.form && this.$refs.form.reset();
      this.$refs.formNewUser && this.$refs.formNewUser.reset();
      this.success();
    },
    isNumber,
  },
  components: {
    UserWizard,
    ListMemberProgress,
    ListUserLog,
    FormChangePassword,
    FileUpload,
    ListMemberReferral,
    ListMemberPackageHistory,
  },
  computed: {
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    },
    canChangePassword() {
      if (
        this.id &&
        this.$store.getters.hasPermission(this.module, "change-password")
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>
